import type { LucideIcon } from 'lucide-react'

interface SettingsActionCardProps {
  icon: LucideIcon
  title: string
  description: string
  onClick: () => void
}

const SettingsActionCard = ({
  icon: Icon,
  title,
  description,
  onClick
}: SettingsActionCardProps) => {
  return (
    <button
      onClick={onClick}
      className="flex gap-3 shadow-sm bg-card rounded-xl p-5 items-center"
    >
      <div className="bg-accent/10 rounded-full items-center max-w-fit p-3">
        <Icon className="w-5 h-5 icon-gradient-secondary" />
      </div>
      <div className="flex flex-col gap-1 text-start">
        <p className="text-text-main font-semibold">{title}</p>
        <p className="text-text-secondary text-start text-xs">{description}</p>
      </div>
    </button>
  )
}

export default SettingsActionCard
